import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable, Subscription, timer, of } from 'rxjs';
import { OddTypeModel } from '~/legacy/ts/categories/categories';
import { OddModel } from '~/legacy/ts/tournaments/tournaments';
import { uiHelper } from '~/helpers/ui.helper';
import { UiConstant } from '~/constant/ui.constant';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { TH } from 'angular-mydatepicker';
import { WebWorkerService } from '../../../modules/workers/web-worker.service';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'liveFixtures',
    templateUrl: './live.fixture.html',
})
export class LiveFixtures implements OnInit, OnDestroy {
    timeStatu: any;

    private subscriptionsToStopOnDestroy: Subscription[] = [];

    constructor(
        public tournamentsService: TournamentsService,
        private _uiHelper: uiHelper,
        private _UiConstant: UiConstant,
        private _webWorkerService: WebWorkerService,
    ) {
        /*this.timeStatu = [1, 3, 5, 6, 12, 14, 15, 27, 29, 31, 33, 35, 84];*/
        this.timeStatu = [3];
    }

    @ViewChild(VirtualScrollerComponent, { static: true })
    private virtualScroller: VirtualScrollerComponent;

    matchCopy: any;
    expanded;
    ayrinti = false;
    selectedOddType = 1;
    @Input('match') match: LiveFixtures;
    @Input() isScoreBox = false;
    @Input() _bufferAmount = 13;

    init: boolean;
    private timer;
    private extraOddtimer;
    extraOddtimer_subscription: Subscription;

    oddTypes: Observable<OddTypeModel[]>;

    expandShowMatchId = null;

    liveData;
    mergedData;
    preData;
    fullmatch: Observable<any[]>;

    isLive = true;
    fixtureStyles = this._UiConstant.fixtureStyles;

    styles = {
        virtualScroll: {
            height: this.tournamentsService.Page_Window_Height - 255 + 'px',
        },
    };

    ngOnInit() {
        this._uiHelper.setTypeOfList('live');
        if (this.init) {
            return;
        }
        this.init = true;
        this.matchCopy = this.match;

        //this.tournamentsService.getLiveFixture(1);
        this.changeSelectedOdds(1);
        this.tournamentsService.activeSport = 'Soccer';
        this.tournamentsService.TerminalSearchValue = '';

        this.tournamentsService.fixturetourId = 0;
        this.tournamentsService.fixturecatId = 0;
        this.tournamentsService.fixturesportId = 1;
        //this.tournamentsService.getSportFixture("live.fixture.ts");
        //Burada tekrar çağrılmasına gerek yok, prefixture.ts de çalışıyor.

        this.expandShowMatchId = this._uiHelper.expandId;
        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.expandIdListener.subscribe(x => {
                this.expandShowMatchId = x;
            }),
        );

        this.liveData = this._uiHelper.liveFilteredData;

        this.reDataBuild(false);
        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.liveFilteredDataListener.subscribe(x => {
                this.liveData = x;
                this.reDataBuild(false);
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.changeSportFixture.subscribe(() => {
                this.reDataBuild(false);
                if (this.virtualScroller) {
                    this.virtualScroller.scrollToPosition(0);
                    //console.warn("this.virtualScroller.scrollToPosition(0) 99");
                }
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.changeSportFixtureSort.subscribe(() => {
                this.reDataBuild(true);
                if (this.virtualScroller) {
                    this.virtualScroller.scrollToPosition(0);
                    //console.warn("this.virtualScroller.scrollToPosition(0) 99");
                }
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.isDateTodayListener.subscribe(x => {
                if (!x) {
                    this.isLive = false;
                } else {
                    this.isLive = true;
                }
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.liveScrollChange.subscribe(x => {
                this.changeScroll(x);
            }),
        );

        this.refreshExtraOdds();

        this.styles = {
            virtualScroll: {
                height: this.isScoreBox ? 'initial' : this.tournamentsService.Page_Window_Height - 255 + 'px',
            },
        };
    }

    reDataBuild(isSorted) {
        const filterParams = {
            liveData: this.liveData,
            isSorted: isSorted,
            activeSortTypeOfLive: this.tournamentsService.activeSortTypeOfLive,
            terminalFixtureList: this.tournamentsService.terminalFixtureList,
            TerminalSearchValue: this.tournamentsService.TerminalSearchValue,
            isLive: this.isLive,
            isScoreBox: this.isScoreBox,
        };

        const workerFixtureData = this._webWorkerService
            .run(this.reDataBuildWorker, filterParams)
            .then(result => {
                this.mergedData = result.mergedData;
                this.fullmatch = of(result.fullmatch);
            })
            .catch(err => {
                console.log('workerLiveData live fixture', err);
            });
    }

    public reDataBuildWorker = e => {
        let preData;
        let liveData = e.liveData;
        const isSorted = e.isSorted;
        const activeSortTypeOfLive = e.activeSortTypeOfLive;
        const terminalFixtureList = e.terminalFixtureList;
        const TerminalSearchValue = e.TerminalSearchValue;
        const isLive = e.isLive;
        const isScoreBox = e.isScoreBox;

        const sortBy = (items: any[], reverse: boolean, sortedBy: string) => {
            let shortedData;

            if (!reverse) {
                if (items != null)
                    shortedData = items.sort((a, b) => {
                        let nameA = a[sortedBy];
                        let nameB = b[sortedBy];
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                    });
            } else {
                shortedData = items.sort((a, b) => {
                    let nameA = a[sortedBy];
                    let nameB = b[sortedBy];
                    if (nameA > nameB) {
                        return -1;
                    }
                    if (nameA < nameB) {
                        return 1;
                    }
                });
            }

            return shortedData;
        };

        if (activeSortTypeOfLive == 'standart') {
            preData = sortBy(terminalFixtureList, false, 'SequenceNumber');
            if (liveData && isSorted) liveData = sortBy(liveData, false, 'Rank');
        } else {
            preData = sortBy(terminalFixtureList, false, 'EventDate');
            liveData = sortBy(liveData, false, 'EventDate');
        }
        let livefiltereddata = liveData;
        if (TerminalSearchValue != undefined && TerminalSearchValue != '') {
            livefiltereddata = livefiltereddata.filter(
                f =>
                    f.HomeTeam.toLowerCase().indexOf(TerminalSearchValue.toLowerCase()) != -1 ||
                    f.AwayTeam.toLowerCase().indexOf(TerminalSearchValue.toLowerCase()) != -1 ||
                    f.HomeTeam.toUpperCase().indexOf(TerminalSearchValue.toUpperCase()) != -1 ||
                    f.AwayTeam.toUpperCase().indexOf(TerminalSearchValue.toUpperCase()) != -1,
            );
        }

        let mergedData = [
            ...(livefiltereddata && isLive ? livefiltereddata : []),
            ...(preData && !isScoreBox ? preData : []),
        ];

        const _mergedDataIndexer = _data => {
            return _data.map((item, i) => {
                item.IndexCount = i;
                item.IndexOdd = i % 2;
                return item;
            });
        };

        mergedData = _mergedDataIndexer(mergedData);
        let tempArr: any[] = Object.values(mergedData) as any[];
        const response = {
            mergedData: mergedData,
            fullmatch: tempArr,
        };

        return response;
    };

    changeScroll(direction) {
        //console.warn('changeScroll');
        const CHANGE_VALUE = 250;
        this.virtualScroller.scrollToPosition(
            this.virtualScroller.viewPortInfo.scrollStartPosition + (direction === 'up' ? CHANGE_VALUE : -CHANGE_VALUE),
        );
        //let panellive = document.getElementById("scrollableContainer");
        //panellive.scrollTo(0, panellive.scrollTop+(direction === 'up' ? CHANGE_VALUE : -CHANGE_VALUE));
    }

    mergedDataIndexer(_data) {
        return _data.map((item, i) => {
            item.IndexCount = i;
            item.IndexOdd = i % 2;
            return item;
        });
    }

    public compareItems(match1: any, match2: any): boolean {
        if (match1 == undefined || match2 == undefined) return true;
        return match1.BetradarMatchId === match2.BetradarMatchId;
    }

    public trackByFn(index: number, complexItem: any): number {
        //return complexItem.MatchId;
        return complexItem.BetradarMatchId;
    }

    indexexpanded = -1;
    expandNotifierHandler(e, k) {
        if (this.expandShowMatchId === e) {
            this._uiHelper.setExpandId(null);
        } else {
            this._uiHelper.setExpandId(e);
        }

        if (e == this.indexexpanded) {
            //this.focusItem(this.indexexpanded, false);
            this.indexexpanded = -1;
        } else {
            this.focusItem(e, true);
        }
    }

    focusItem(matchId, isFocusEnabled) {
        this.indexexpanded = matchId;
        const tmpix = this.mergedData.findIndex(s => s.MatchId == matchId);
        if (isFocusEnabled) this.virtualScroller.scrollInto(this.mergedData[tmpix]);
        //console.log(this.virtualScroller);

        //this.virtualScroller.invalidateAllCachedMeasurements();
        //console.warn("invalidateCachedMeasurementAtIndex focusItem");
        //this.virtualScroller.invalidateCachedMeasurementAtIndex(tmpix);
        this.virtualScroller.invalidateAllCachedMeasurements();
    }
    _scrollEndPosition;
    vsChanged(e) {
        //console.warn('changed', e);
    }
    vsEnd(e) {
        //console.warn('end', e);
        //this.virtualScroller.window.
        this._scrollEndPosition = e.scrollStartPosition;
    }
    vsStart(e) {
        //console.warn('start', e);
    }

    changeSelectedOdds(e) {
        this.selectedOddType = e;
        //this.matchCopy.Loading = "active";
        this.oddTypes = this.tournamentsService.getOddType(e, this.matchCopy);
    }

    clickOdd(oddId, visibility) {
        if (this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }

        if (visibility != 'hidden') {
            this.tournamentsService.addLiveOdd(oddId, $('input[name="__RequestVerificationToken"]').val());

            this.tournamentsService.matchtimeScore = 'Live';
        }
    }

    checkOddId(oddId) {
        const index = this.tournamentsService.slipCurrents.findIndex(v => {
            return v.OddId1 == oddId;
        });
        if (index > -1) {
            return 'eylem';
        } else {
            return '';
        }
    }

    getBgColorOddDetailsColumn(i) {
        if (i % 2 == 0) {
            return '#173C10';
        } else {
            return '#1A690D';
        }
    }

    getBgColorOddDetails(i) {
        if (i % 2 == 0) {
            return '#2A661E';
        } else {
            return '#3D7433';
        }
    }

    getBgColorEOU(e, i) {
        if (this.timeStatu.find(x => x == e.TimeStatu) != null) {
            return '#064FA6';
        }

        if (i % 2 == 0) {
            return 'linear-gradient(rgb(87,178,59), rgb(56,148,37))';
        } else {
            return 'linear-gradient(rgb(15,82,39), rgb(12,76,36))';
        }
    }

    getbgcolorEouHT(e, i) {
        if (this.timeStatu.find(x => x == e.TimeStatu) != null) {
            return '#064FA6';
        }

        if (i % 2 == 0) {
            return 'linear-gradient(rgb(56,148,37), rgb(49,131,31))';
        } else {
            return 'linear-gradient(rgb(12,76,36), rgb(5,68,29))';
        }
    }

    getBgBorder(e, i) {
        if (this.timeStatu.find(x => x == e.TimeStatu) != null) {
            return '1px solid #064FA6';
        }

        if (i % 2 == 0) {
            return '1px solid rgb(56,148,37)';
        } else {
            return '1px solid rgb(12,76,36)';
        }
    }

    getBgColorTGS(e, i) {
        if (this.timeStatu.find(x => x == e.TimeStatu) != null) {
            return '#2670CA';
        }

        if (i % 2 == 0) {
            return 'linear-gradient(rgba(103,177,73,1),rgba(103,177,73,1))';
        } else {
            return 'linear-gradient(rgba(75,150,103,1),rgba(75,150,103,1))';
        }
    }

    getBgBorderTGS(e, i) {
        if (this.timeStatu.find(x => x == e.TimeStatu) != null) {
            return '1px solid #2670CA';
        }

        if (i % 2 == 0) {
            return '1px solid rgba(103,177,73,1)';
        } else {
            return '1px solid rgba(75,150,103,1)';
        }
    }

    AddExpand(e) {
        const index = this.tournamentsService.isExpandedObservable.findIndex(v => {
            return v.EventId == e.EventId;
        });
        if (index == -1) {
            this.tournamentsService.isExpandedObservable.unshift(e);

            let tmplist: any;
            tmplist = this.tournamentsService.getLiveEventOdds(12, e.EventId);
            this.subscriptionsToStopOnDestroy.push(
                tmplist.subscribe(res => {
                    e.Odds = res;
                }),
            );
            //this.tournamentsService.getLiveEventOddsPush(e);
            this.tournamentsService.extraODDs.unshift(e);
        } else {
            this.tournamentsService.isExpandedObservable.splice(index, 1);
            this.tournamentsService.extraODDs.splice(index, 1);
        }
    }

    CheckExpand(e) {
        const index = this.tournamentsService.isExpandedObservable.findIndex(v => {
            return v.EventId == e.EventId;
        });
        if (index > -1) {
            //var tmplist: any;
            //tmplist = this.tournamentsService.getLiveEventOdds(1, e.EventId);
            //tmplist.subscribe(res => { this.tournamentsService.isExpandedObservable[index].Odds = res; })
            e.Odds = this.tournamentsService.isExpandedObservable[index].Odds;
            return true;
        } else {
            return false;
        }
    }

    refreshExtraOdds() {
        if (this.extraOddtimer_subscription != undefined) {
            return;
        }

        this.extraOddtimer = timer(1000, 10000);
        this.extraOddtimer_subscription = this.extraOddtimer.subscribe(t => {
            for (const e of this.tournamentsService.extraODDs) {
                const index = this.tournamentsService.isExpandedObservable.findIndex(v => {
                    return v.EventId == e.EventId;
                });
                if (index > -1) {
                    let tmplist: any;
                    tmplist = this.tournamentsService.getLiveEventOdds(12, e.EventId);
                    this.subscriptionsToStopOnDestroy.push(
                        tmplist.subscribe(res => {
                            e.Odds = res;
                        }),
                    );
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.extraOddtimer_subscription != undefined) {
            this.extraOddtimer_subscription.unsubscribe();
        }

        for (let subscription of this.subscriptionsToStopOnDestroy) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

    //getExOdds(e) {
    //    var index = this.tournamentsService._liveextraodds.findIndex((v) => { return v.EventId == e.EventId });
    //    if (index > -1) {

    //        return this.tournamentsService._liveextraodds[index].Odds;
    //    }
    //    else
    //        return null;
    //}

    get1stHalfs(e, listitem) {
        let result;

        if (listitem != null) {
            return listitem.find(s => s.EventId == e.EventId);
        } else {
            return null;
        }
    }

    // UP COMİNG
    //deprecated
    //clickOddUP(oddId) {
    //  //console.log("ODD_ID", oddId)
    //  this.tournamentsService.addOdd(oddId, $('input[name="__RequestVerificationToken"]').val());

    //  this.tournamentsService.matchtimeScore = "UpComing";
    //}

    expandUP(e) {
        if (e.isExpanded) {
            e.isExpanded = false;
        } else {
            e.isExpanded = true;
            e.Odds = this.tournamentsService.getOddType(12, e.MatchId);
        }
    }

    getBgColorEOUP(i) {
        if (i % 2 == 0) {
            return '#1C1C1C';
        } else {
            return '#404040';
        }
    }

    getBgColorTGSUP(i) {
        if (i % 2 == 0) {
            return '#323232';
        } else {
            return '#525252';
        }
    }

    getHomeTeamCard(e) {
        if (this.tournamentsService._cardList != null) {
            const card = this.tournamentsService._cardList.find(s => s.EventId == e);
            if (card != null) {
                if (card.HomeTeamRed != null) {
                    return card.HomeTeamRed;
                }
            }
        }
        return '0';
    }

    getAwayTeamCard(e) {
        if (this.tournamentsService._cardList != null) {
            const card = this.tournamentsService._cardList.find(s => s.EventId == e);
            if (card != null) {
                if (card.AwayTeamRed != null) {
                    return card.AwayTeamRed;
                }
            }
        }
        return '0';
    }

    getOddChange(e, oddtype) {
        if (this.tournamentsService._liveoldSoccer != undefined) {
            if (e != undefined) {
                const oldodd = this.tournamentsService._liveoldSoccer.find(s => s.EventId == e.EventId);
                if (oldodd != undefined) {
                    if (oddtype == 'RestThreeWay1') {
                        if (oldodd.RestThreeWay1 < e.RestThreeWay1) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWay1 > e.RestThreeWay1) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'RestThreeWayX') {
                        if (oldodd.RestThreeWayX < e.RestThreeWayX) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWayX > e.RestThreeWayX) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'RestThreeWay2') {
                        if (oldodd.RestThreeWay2 < e.RestThreeWay2) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWay2 > e.RestThreeWay2) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'TotalOver') {
                        if (oldodd.TotalOver < e.TotalOver) {
                            return 'uparrow';
                        } else if (oldodd.TotalOver > e.TotalOver) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'TotalUnder') {
                        if (oldodd.TotalUnder < e.TotalUnder) {
                            return 'uparrow';
                        } else if (oldodd.TotalUnder > e.TotalUnder) {
                            return 'downarrow';
                        }
                    }
                }
            }
        }
        return '';
    }

    getOddChange1stHalf(e, oddtype) {
        if (this.tournamentsService._oldhalftimeList != undefined) {
            if (e != undefined) {
                const oldodd = this.tournamentsService._oldhalftimeList.find(s => s.EventId == e.EventId);
                if (oldodd != undefined) {
                    if (oddtype == 'RestThreeWay1') {
                        if (oldodd.RestThreeWay1 < e.RestThreeWay1) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWay1 > e.RestThreeWay1) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'RestThreeWayX') {
                        if (oldodd.RestThreeWayX < e.RestThreeWayX) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWayX > e.RestThreeWayX) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'RestThreeWay2') {
                        if (oldodd.RestThreeWay2 < e.RestThreeWay2) {
                            return 'uparrow';
                        } else if (oldodd.RestThreeWay2 > e.RestThreeWay2) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'NextGoal1') {
                        if (oldodd.NextGoal1 < e.NextGoal1) {
                            return 'uparrow';
                        } else if (oldodd.NextGoal1 > e.NextGoal1) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'NextGoalX') {
                        if (oldodd.NextGoalX < e.NextGoalX) {
                            return 'uparrow';
                        } else if (oldodd.NextGoalX > e.NextGoalX) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'NextGoal2') {
                        if (oldodd.NextGoal2 < e.NextGoal2) {
                            return 'uparrow';
                        } else if (oldodd.NextGoal2 > e.NextGoal2) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'TotalOver') {
                        if (oldodd.TotalOver < e.TotalOver) {
                            return 'uparrow';
                        } else if (oldodd.TotalOver > e.TotalOver) {
                            return 'downarrow';
                        }
                    } else if (oddtype == 'TotalUnder') {
                        if (oldodd.TotalUnder < e.TotalUnder) {
                            return 'uparrow';
                        } else if (oldodd.TotalUnder > e.TotalUnder) {
                            return 'downarrow';
                        }
                    }
                }
            }
        }
        return '';
    }

    sortBy(items: any[], reverse: boolean, sortedBy: string) {
        let shortedData;

        if (!reverse) {
            if (items != null)
                shortedData = items.sort((a, b) => {
                    let nameA = a[sortedBy];
                    let nameB = b[sortedBy];
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                });
        } else {
            shortedData = items.sort((a, b) => {
                let nameA = a[sortedBy];
                let nameB = b[sortedBy];
                if (nameA > nameB) {
                    return -1;
                }
                if (nameA < nameB) {
                    return 1;
                }
            });
        }

        return shortedData;
    }
}
